import React from 'react';

import OfflineSigningEmail from './EmailPreviewContent/OfflineSigningEmail';
import OnlineSigningEmail from './EmailPreviewContent/OnlineSigningEmail';

import type { Person, Property } from '../../models';
import type { LandlordProvidedDocument } from '../../models/Types';

type Props = {
  isInSignOnlineMode: boolean;
  landlordProvidedDocuments: Array<LandlordProvidedDocument>;
  tenant: Person;
  landlord: Person;
  property: Property;
  isSelfUpload?: boolean;
  personalNote: string;
};

export default function EmailPreviewContent(props: Props) {
  const { isInSignOnlineMode, landlordProvidedDocuments, tenant, landlord, property, isSelfUpload, personalNote } =
    props;
  const childProps = { landlordProvidedDocuments, tenant, landlord, property, personalNote };

  return isInSignOnlineMode ? (
    <OnlineSigningEmail {...childProps} isSelfUpload={isSelfUpload} />
  ) : (
    <OfflineSigningEmail {...childProps} />
  );
}
